import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private tokenService: TokenService, private router : Router){}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):  boolean {

    let autenticado = this.tokenService.isTokenValido();

    if(autenticado){
      return true;
    }else{
      this.router.navigate(['/login']);
      return false;
    }
  }

}
